export default "__VITE_ASSET__BGq11c5$__"